export default "__VITE_ASSET__DKpX9bxi__"